var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSakeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0077 99.7686C48.0127 99.7686 48.0164 99.7734 48.015 99.7783V99.7783C48.0126 99.7869 48 99.7851 48 99.7762V99.7762C48 99.772 48.0034 99.7686 48.0077 99.7686V99.7686Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5074 99.7686C94.5139 99.7686 94.5191 99.7738 94.5191 99.7802V99.7802C94.5191 99.7938 94.4998 99.7964 94.4962 99.7833V99.7833C94.4942 99.7759 94.4998 99.7686 94.5074 99.7686V99.7686Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.33 139.537C131.337 150.25 128.733 159.133 127.66 162.339C127.398 163.12 126.663 163.62 125.839 163.62H97.8468C97.0217 163.62 96.2843 163.114 96.0232 162.331C95.6493 161.211 95.09 159.401 94.519 157.066C94.5188 157.066 94.5187 157.065 94.5187 157.064C94.518 157.057 94.5133 157.051 94.5152 157.044C94.5159 157.042 94.5145 157.038 94.512 157.038V157.038C94.5107 157.038 94.5096 157.038 94.5093 157.036C93.4496 152.681 92.3544 146.492 92.3633 139.537C92.3722 134.567 93.3163 129.401 94.5187 124.868C96.435 117.586 98.9903 111.91 99.3123 111.207C99.335 111.158 99.3554 111.118 99.3823 111.07C99.9168 110.127 106.196 98.9673 106.213 95.1555C106.234 92.0792 104.107 80.5735 103.147 75.5395C102.91 74.302 103.859 73.1562 105.119 73.1562H118.559C119.818 73.1562 120.766 74.3007 120.531 75.5377C119.575 80.5706 117.455 92.0788 117.462 95.1555C117.488 98.9665 123.773 110.123 124.31 111.07C124.337 111.118 124.355 111.151 124.378 111.201C124.88 112.296 131.312 126.579 131.33 139.537Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.519 124.607C94.519 124.78 94.4965 124.952 94.4527 125.119C93.2821 129.591 92.3724 134.658 92.3636 139.536C92.3547 146.49 93.4496 152.679 94.5092 157.034C94.5098 157.036 94.5117 157.038 94.514 157.038V157.038C94.5168 157.038 94.519 157.04 94.519 157.043C94.519 157.049 94.519 157.059 94.519 157.065V161.62C94.519 162.724 93.6236 163.62 92.519 163.62H50C48.8954 163.62 48 162.724 48 161.62V109.838C48 108.733 48.8954 107.838 50 107.838H92.519C93.6236 107.838 94.519 108.733 94.519 109.838V124.607Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4923 99.7688C94.51 99.8338 94.519 99.9009 94.519 99.9683V105.838C94.519 106.943 93.6236 107.838 92.519 107.838H50C48.8954 107.838 48 106.943 48 105.838V99.896C48 99.853 48.006 99.8102 48.0178 99.7688V99.7688L64.5869 45.1794C64.6441 44.9911 64.6731 44.7954 64.6731 44.5986V19C64.6731 17.8954 65.5685 17 66.6731 17H75.748C76.8525 17 77.748 17.8954 77.748 19V44.597C77.748 44.7948 77.7773 44.9916 77.835 45.1808L94.4923 99.7688V99.7688Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92 153H48",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2632 144.809C75.9854 144.809 79.8135 139.27 79.8135 132.438C79.8135 125.605 75.9854 120.066 71.2632 120.066C66.541 120.066 62.7129 125.605 62.7129 132.438C62.7129 139.27 66.541 144.809 71.2632 144.809Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7487 29.5576H64.6738",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSakeIcon);
export default __webpack_public_path__ + "static/media/sake-icon.fea5f0038b552d792ecef48fbd82d35b.svg";
export { ForwardRef as ReactComponent };